import { render, staticRenderFns } from "./BizInsuranceWithTypeForm.vue?vue&type=template&id=2358af47&"
import script from "./BizInsuranceWithTypeForm.vue?vue&type=script&lang=js&"
export * from "./BizInsuranceWithTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports